import React, { Component } from 'react';
import moment from 'moment';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { DisputeProgressComponent } from './DisputeProgressComponent';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import {
  DateOfBirthInput,
  GenericTextArea,
} from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import FraudAndDisputeActionCreator from '../../../actions/FraudAndDisputeActionCreator';
import FraudAndDisputeStore from '../../../stores/FraudAndDisputeStore';
import {
  DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH,
  DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH,
  MAXIMUM_DISPUTE_THRESHOLD_DAYS,
  PAGE_MAXIMUM_DISPUTE_THRESHOLD,
  PAGE_WHAT_DIDNT_YOU_RECEIVE,
  PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER,
} from '../../../constants/FraudAndDisputeConstants';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';

export class DescribeTheGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveryDate: FraudAndDisputeStore.getGoodsExptectedDeliveryDate(),
      descriptionText: FraudAndDisputeStore.getGoodsDescriptionText(),
      validationErrorReason: null,
      deliveryDateError: false,
      descriptionTextError: false,
      descriptionTextValidationMessage:
        props.content.goodsDescriptionTextValidationMessage,
      deliveryDateValidationMessage:
        props.content.deliveryDateValidationMessage,
    };
  }

  onContinueClick = () => {
    const { deliveryDate, descriptionText } = this.state;
    const { content, setPage } = this.props;
    !deliveryDate &&
      this.setState({
        deliveryDateError: true,
        deliveryDateValidationMessage: content.deliveryDateValidationMessage,
      });
    (!descriptionText || (descriptionText && !descriptionText.trim().length)) &&
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.goodsDescriptionTextValidationMessage,
      });
    if (
      deliveryDate &&
      deliveryDate <= new Date() &&
      descriptionText &&
      descriptionText.trim().length >=
        DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH &&
      descriptionText.trim().length <=
        DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      /**
       * Happy path - completed validation.
       * TODOxVM Simplify this methods logic
       */

      if (moment().diff(deliveryDate, 'day') > MAXIMUM_DISPUTE_THRESHOLD_DAYS) {
        setPage(PAGE_MAXIMUM_DISPUTE_THRESHOLD);
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_maximum_days_threshold,
          config.analytics.analytics_action_button_click
        );
        return;
      }

      this.setState({ deliveryDateError: false, descriptionTextError: false });
      FraudAndDisputeActionCreator.setGoodsExpectedDeliveryDate(deliveryDate);
      FraudAndDisputeActionCreator.setGoodsDescriptionText(descriptionText);
      setPage(PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER);
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_action_dispute_describe_the_goods,
        config.analytics.analytics_action_button_click
      );
      return;
    }
    if (
      descriptionText &&
      descriptionText.trim().length >=
        DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH &&
      descriptionText.trim().length <=
        DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: false,
      });
    }
    if (
      descriptionText &&
      descriptionText.trim().length < DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.goodsDescriptionTextValidationMessage2,
      });
    }
    if (
      descriptionText &&
      descriptionText.trim().length > DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.goodsDescriptionTextValidationMessage3,
      });
    }
    if (deliveryDate && deliveryDate <= new Date()) {
      this.setState({
        deliveryDateError: false,
      });
    }
    if (deliveryDate && deliveryDate > new Date()) {
      this.setState({
        deliveryDateError: true,
        deliveryDateValidationMessage: content.enterCurrentDateOrEarlier,
      });
    }
  };
  render() {
    const { content, setPage } = this.props;
    const {
      deliveryDate,
      descriptionText,
      deliveryDateError,
      descriptionTextError,
      descriptionTextValidationMessage,
      deliveryDateValidationMessage,
    } = this.state;
    return (
      <div>
        <ApplicationFormShell
          leftSidebar={
            <DisputeProgressComponent
              items={content.disputeProgressStepperItems}
              currentId="3"
            />
          }
        >
          <PageHeading>{content.describeTheGoodsHeader}</PageHeading>
          <StandardBody>
            <strong>{content.describeTheGoodsSubText}</strong>
          </StandardBody>
          <div className="web-ui-components">
            <GenericFieldWrapper
              titleText={content.expectedDeliveryDate}
              validationMessage={
                deliveryDateError && deliveryDateValidationMessage
              }
            >
              {/* @todo - This should be replaced once the generic DD-MM-YYYY component is available in the web ui lib */}

              <DateOfBirthInput
                id="delivery-date"
                onChange={(obj) =>
                  this.setState({
                    deliveryDate: obj.value,
                  })
                }
                value={deliveryDate}
              />
            </GenericFieldWrapper>
            <GenericFieldWrapper
              titleText={content.describeTheGoods}
              validationMessage={
                descriptionTextError && descriptionTextValidationMessage
              }
            >
              <GenericTextArea
                id="goods-description-text"
                characterWidth={40}
                hideCharacterCount
                onChange={({ value }) => {
                  this.setState({ descriptionText: value });
                }}
                value={descriptionText}
              />
            </GenericFieldWrapper>
          </div>
          <div className="button-group">
            <NavigationButton.Secondary
              labelText={content.back}
              onClick={() => {
                setPage(PAGE_WHAT_DIDNT_YOU_RECEIVE);
              }}
            />
            <NavigationButton.Primary
              labelText={content.continueButtonText}
              onClick={this.onContinueClick}
            />
          </div>
        </ApplicationFormShell>
      </div>
    );
  }
}
